import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVR42oXNSwqAIAAAUe9/M1tVBOGqH0aFkEiGZTgRtK5ZPxjBd5dIMWIyydhppnXDuB3rAz6cLzgCtq7IVY9UmqKZKduFwTjSA/4WN+uOe7L1q7zvAAAAAElFTkSuQmCC"};
